import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMicOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function _(e, i, l, h, g, t) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--mic-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Mic Off",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M.646.646a.5.5 0 0 1 .708 0l7.5 7.5 2.5 2.5a.5.5 0 0 1-.708.708L8.481 9.188a4 4 0 0 1-1.981.832V11H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5v-.98A4.001 4.001 0 0 1 2 5.996V5a.5.5 0 0 1 1 0v1.007a3 3 0 0 0 4.768 2.468l-.753-.753A2 2 0 0 1 4 6V4.707L.646 1.354a.5.5 0 0 1 0-.708ZM5 5.707V6a1 1 0 0 0 1.258.965L5 5.707Zm.153-5.01A2 2 0 0 1 8 2.497V4.67a.5.5 0 0 1-1 0V2.502a1 1 0 0 0-1.893-.442.5.5 0 0 1-.894-.45 2 2 0 0 1 .94-.913ZM9.5 4.5a.5.5 0 0 1 .5.5v1.001c0 .235-.022.47-.063.702a.5.5 0 1 1-.984-.176A3.06 3.06 0 0 0 9 6V5a.5.5 0 0 1 .5-.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const q = /* @__PURE__ */ u(c, [["render", _]]);
export {
  q as default
};
//# sourceMappingURL=mic-off.js.map
